import React, { useState } from 'react';
import { Icon, TooltipHost } from '@fluentui/react';
import EditModal from '../../EditSite/EditModal';
import SiteHistoryModal from '../SiteDetails/SiteHistoryModal';
import { PowerAppProvisioningStatus } from '../../../GlobalConst/globalEnums';

const UPDATING_STATUSES = [
    PowerAppProvisioningStatus.updating,
    PowerAppProvisioningStatus.pendingApproval,
    PowerAppProvisioningStatus.failed,
    PowerAppProvisioningStatus.permanentFailed,
    PowerAppProvisioningStatus.partiallyFailed
];

const SolutionActionButtonsView = ({ editedItem, callBack, filterBy }) => {

    const [showEditModal, setShowEditModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);

    const isAdminView = filterBy !== 'owner';
    const isUpdating = !isAdminView && UPDATING_STATUSES.includes(editedItem.provisioningStatus);
    const shouldShowEditButton = editedItem.isHighestSolution

    return (
        <div style={styles.iconContainer}>
            {
                isUpdating 
                ? <TooltipHost content='Updates are in progress' styles={styles.icon}>
                    <Icon iconName='workflow' style={styles.updatesIcon} />
                </TooltipHost>
                : <div style={{ visibility: shouldShowEditButton ? 'visible' : 'hidden' }}>
                    <Icon 
                        style={styles.editIcon} 
                        onClick={() => setShowEditModal(true)} 
                        iconName="edit" 
                    />
                    <EditModal
                        itemId={editedItem.id}
                        isModalOpened={showEditModal}
                        onCloseModal={() => setShowEditModal(false)}
                        callBack={callBack}
                        isPowerAppSolution={true}
                    />
                </div>
            }
            
            {isAdminView && (
                <div>
                    <Icon 
                        style={styles.icon} 
                        onClick={() => setShowHistoryModal(true)} 
                        iconName="diagnostic" 
                    />
                    <SiteHistoryModal
                        powerAppSolutionId={editedItem.id}
                        title={editedItem.name}
                        isModalOpened={showHistoryModal}
                        onCloseModal={() => setShowHistoryModal(false)}
                    />
                </div>
            )}
        </div>
    );
};

const styles = {
    iconContainer: {
        display: 'flex'
    },
    editIcon: {
        cursor: 'pointer',
        margin: '1px 5px',
        fontSize: '14px',
        fontWeight: '600'
    },
    icon: {
        cursor: 'pointer',
        margin: '0 5px',
        fontSize: '16px',
        fontWeight: '600'
    },
    updatesIcon: {
        fontSize: '16px',
        color: 'orange',
        margin: '0 5px',
        cursor: 'default'
    }
};

export default SolutionActionButtonsView;


// WEBPACK FOOTER //
// ./src/components/Administration/PowerPlatform/SolutionActionButtonsView.js